import React, { memo } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { cx } from "@jugl-web/utils";
import loaderAnimation from "./animations/loaderAnimation.json";

export interface LoaderProps {
  className?: string;
}

const LoaderComponent: React.FC<LoaderProps> = ({ className }) => (
  <div
    className={cx("flex h-full w-full items-center justify-center", className)}
  >
    <Lottie
      options={{
        animationData: loaderAnimation,
      }}
      height={100}
      width={100}
    />
  </div>
);

export const Loader = memo(LoaderComponent);
